/* eslint no-console: 0 */
/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect, useState } from 'react'
import { useLoading } from '../../../../../presentation/contexts/loading'
import { useMe } from '../../../../../presentation/contexts/me'
import { usePage } from '../../../../../presentation/contexts/page'
import { useSnackbar } from '../../../../../presentation/contexts/snackbar'
import EstablishmentEditor from '../../../../../presentation/pages/dashboard/configurations/establishment/editor'
import { theme } from '../../../../../presentation/styles/theme'
import { makeMe } from '../../../../usecases/me/load-me-factory'
import { makeStablishments } from '../../../../usecases/stablishments/load-stablishments'
import { makeFiles } from '../../../../usecases/files/load-files'

const MakeEstablishmentEditor = () => {
  const [initialFormData, setInitialFormData] = useState<any>(null)
  const { setHeader } = usePage()
  const { me, updateMe } = useMe()
  const { onSetLoading } = useLoading()
  const { setIsShowing, setText, setType } = useSnackbar()

  const loadFile = async () => {
    if (!me) return
    const stablishmentId = me.stablishments[0].id
    const { file } = await makeFiles().load(stablishmentId)
    const data = { file }
    setInitialFormData(data)
  }

  useEffect(() => {
    (async () => {
      setHeader({
        title: 'Configuração do estabelecimento',
        goTo: null,
      })
      onSetLoading(true)
      try {
        await loadFile()
      } catch (error) {
        console.log(error)
      } finally {
        onSetLoading(false)
      }
    })()
  }, [me])

  const dataForm = [
    {
      items: [
        {
          name: 'file',
          label: 'Imagem do estabelecimento',
          title: 'Imagem do estabelecimento',
          component: 'InputUpload',
          required: true,
          // validations: 'inputRequired',
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Salvar',
          submittingText: 'Salvando...',
          style: { background: theme.colors.blue, width: '25%', marginTop: '0px' },
        },
      ],
    },
  ]

  const onSubmit = async (values:any): Promise<void> => {
    const formData = new FormData()
    formData.append('logoImage', values.file)

    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      await makeStablishments().patch(stablishmentId, formData)
      await loadFile()
      const { user } = await makeMe().load()
      updateMe(user)
      setType('success')
      setText('Salvo com sucesso!')
      setIsShowing(true)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <EstablishmentEditor
      initialData={initialFormData}
      dataForm={dataForm}
      onSubmit={onSubmit}
    />
  )
}

export default MakeEstablishmentEditor
